import { get } from './genericService';

export function getPaymentsDueCard(success, failed) {
  return get('/api/v1/account/payments-due/summary', success, failed);
}
